import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28db64e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_2 = { style: {"width":"200px","height":"20%","margin-right":"10px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "请求编号", -1))
const _hoisted_4 = { style: {"width":"200px","margin-right":"10px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "用户", -1))
const _hoisted_6 = { style: {"width":"200px","margin-right":"10px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "角色", -1))
const _hoisted_8 = { style: {"width":"200px","margin-right":"10px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "终端IP", -1))
const _hoisted_10 = { style: {"width":"200px","margin-right":"10px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "终端ID", -1))
const _hoisted_12 = { style: {"width":"200px","margin-right":"10px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "租户", -1))
const _hoisted_14 = { style: {"width":"200px","margin-right":"10px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "应用", -1))
const _hoisted_16 = { style: {"width":"200px","margin-right":"10px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "操作", -1))
const _hoisted_18 = { style: {"margin-right":"10px"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"2px"} }, "操作简称", -1))
const _hoisted_20 = { style: {"margin-top":"20px","background":"#fff","padding":"0 0 20px","border-radius":"4px"} }
const _hoisted_21 = ["title", "onClick"]
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = { style: {"padding":"0 30px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_Screen = _resolveComponent("Screen")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      ref: "formRef",
      class: "a_form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Screen, {
          onSearch: _ctx.search,
          onReset: _ctx.reset,
          subSlot: 5,
          formState: _ctx.formState,
          "onUpdate:formState": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState) = $event)),
          keepformState: _ctx.keepformState
        }, {
          topRight: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: " ",
              name: "activeTime",
              rules: _ctx.rules,
              colon: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  style: {"width":"280px"},
                  value: _ctx.formState.activeTime,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.activeTime) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"]),
                  valueFormat: "x",
                  showTime: "",
                  allowClear: false
                }, null, 8, ["value", "onKeyup"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_a_input, {
                  placeholder: "请输入...",
                  allowClear: "",
                  size: "small",
                  value: _ctx.formState.traceId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.traceId) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"])
                }, null, 8, ["value", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_a_input, {
                  placeholder: "请输入...",
                  allowClear: "",
                  size: "small",
                  value: _ctx.formState.nickname,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.nickname) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"])
                }, null, 8, ["value", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_a_input, {
                  placeholder: "请输入...",
                  allowClear: "",
                  size: "small",
                  value: _ctx.formState.roleName,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.roleName) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"])
                }, null, 8, ["value", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_a_input, {
                  placeholder: "请输入...",
                  allowClear: "",
                  size: "small",
                  value: _ctx.formState.remoteIp,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.remoteIp) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"])
                }, null, 8, ["value", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_a_input, {
                  placeholder: "请输入...",
                  allowClear: "",
                  size: "small",
                  value: _ctx.formState.clientId,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.clientId) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"])
                }, null, 8, ["value", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_a_form_item, {
                  label: " ",
                  name: "tenantInfo",
                  colon: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: "请输入...",
                      allowClear: "",
                      size: "small",
                      value: _ctx.formState.tenantInfo,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.tenantInfo) = $event)),
                      onKeyup: _withKeys(_ctx.search, ["enter"])
                    }, null, 8, ["value", "onKeyup"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_a_form_item, {
                  label: " ",
                  name: "appName",
                  rules: _ctx.rulesAppName,
                  colon: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: "请输入...",
                      allowClear: "",
                      size: "small",
                      value: _ctx.formState.appName,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.appName) = $event)),
                      onKeyup: _withKeys(_ctx.search, ["enter"])
                    }, null, 8, ["value", "onKeyup"])
                  ]),
                  _: 1
                }, 8, ["rules"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_a_input, {
                  placeholder: "请输入...",
                  allowClear: "",
                  size: "small",
                  value: _ctx.formState.actionName,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.actionName) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"])
                }, null, 8, ["value", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_a_select, {
                  placeholder: "选择操作简称",
                  allowClear: "",
                  style: {"width":"410px"},
                  value: _ctx.formState.aid,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.aid) = $event)),
                  onKeyup: _withKeys(_ctx.search, ["enter"]),
                  "show-search": "",
                  "default-active-first-option": false,
                  "show-arrow": false,
                  "filter-option": false,
                  "not-found-content": _ctx.fetching ? undefined : null,
                  onSearch: _ctx.handleActionNameFetch,
                  onChange: _ctx.handleActionNameChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionNames, (d) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: d.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(d.text), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onKeyup", "not-found-content", "onSearch", "onChange"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSearch", "onReset", "formState", "keepformState"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", null, [
        _createVNode(_component_a_table, {
          rowKey: "traceId",
          columns: _ctx.columns,
          "data-source": _ctx.data,
          pagination: false,
          scroll: _ctx.scroll,
          loading: _ctx.loading,
          size: "small",
          bordered: "",
          customRow: _ctx.rowClick
        }, {
          traceId: _withCtx(({ record }) => [
            _createElementVNode("span", {
              class: "traceId",
              title: record.traceId,
              onClick: _withModifiers(($event: any) => (_ctx.$store.state.same.copy(record.traceId)), ["stop"]),
              style: {"cursor":"pointer"}
            }, _toDisplayString(record.traceId), 9, _hoisted_21)
          ]),
          remoteType: _withCtx(({ record }) => [
            _createElementVNode("span", {
              title: record.remoteType
            }, _toDisplayString(record.remoteType), 9, _hoisted_22)
          ]),
          reqTime: _withCtx(({ record }) => [
            _createElementVNode("span", {
              title: record.reqTime,
              class: _normalizeClass(Number(record.reqTime) >= 0.5 ? 'red' : '')
            }, _toDisplayString(record.reqTime) + " s ", 11, _hoisted_23)
          ]),
          actionName: _withCtx(({ record }) => [
            _createElementVNode("div", {
              class: "actionName",
              title: record.path
            }, _toDisplayString(record.actionName), 9, _hoisted_24)
          ]),
          status: _withCtx(({ record }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["status", 
                record.status[0] != 2 && record.status[0] != 3 ? 'waring' : ''
              ])
            }, _toDisplayString(record.status), 3)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll", "loading", "customRow"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_Pagination, {
          total: _ctx.total,
          onChangePagination: _ctx.changePagination,
          defaultPageSize: 20,
          pageSizeOptions: ['10', '20', '50', '100']
        }, null, 8, ["total", "onChangePagination"])
      ])
    ]),
    _createVNode(_component_Modal, { ref: "Modal" }, null, 512)
  ]))
}